@if (message) {
  <div [ngStyle]="message.state ? {'background':'green'} : { 'background':'red'}" class="message-view">
    <span class="message-view__text" tabindex="0" autofocus #messageView>{{message.message | translate: message.params}}</span>
    @if (gs.bShowOverbookingErrorDialog) {
      <div class="overlap-booking-error-action-container">
        <app-button [buttontype]="secondaryButton" (valueChange)="closeMessage()"></app-button>
        <app-button [buttontype]="primaryButton" (valueChange)="emitOverlapBookingproceedEvent()"></app-button>
      </div>
    }
    @if (!gs.bShowOverbookingErrorDialog) {
      <span class="message-view__close icon-close" (click)="closeMessage()" tabindex="0" [attr.aria-label]="'Close' | translate"></span>
    }
  </div>
}